import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import CommonDivWidget from 'components/CommonDivWidget/CommonDivWidget'
import { message, Spin, DatePicker, Row, Col } from 'antd';
import CommonButton from 'components/ButtonWidgets/CommonButton/CommonButton';
import { TitleSearch } from 'components/SearchWidget/TitleSearch';
import { useHistory } from 'react-router-dom';
import { UpdateCurrentRoot } from 'redux/actions/appActions';
import TableWidget from './TableWidget/TableWidget';
import { showAddUserDialog } from './AddUserDialog/showAddUserDialog';
import { apiCreateUser, apiDeleteUser, apiGetUserList, apiUpdateUser } from 'services/userService';
const { RangePicker } = DatePicker;

function UsersPage() {
    const history = useHistory();
    const dispatch = useDispatch();
    const [isBusy, setIsBusy] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [searchList, setSearchList] = useState([]);

    useEffect(() => {
        apiGetUserList()
        .then((data) => {
            setSearchList(data)
            setDataList(data)
        })
        .catch((err) => {
            // message.error("Sorry! " + err);
        });
    }, []);

    const handleSearch = (searchText) => {
        const tmpList = dataList.filter((info) => info.first_name.toLowerCase().includes(searchText.toLowerCase()))
        setSearchList([...tmpList])
    };
    const handleChange = (event) => {
        if (event.target.value === "") {
            setSearchList(dataList)
        }
        else {
            handleSearch(event.target.value)
        }
    };
    const onNewUser = async () => {
        var res = await showAddUserDialog({
            title: "New User",
            isEditing: false
        });
        if (res === null) return;
        setIsBusy(true)
        apiCreateUser(res)
            .then((data) => {
                setIsBusy(false);
                if (data === null) {
                    message.error("There's something wrong while adding New User");
                }
                var tmpData = dataList;
                let updateData = [...dataList];
                updateData.splice(tmpData.length, 0, data);
                tmpData = [...updateData];
                setDataList(tmpData)
                setSearchList(tmpData)
            })
            .catch((err) => {
                setIsBusy(false);
                message.error("Error! " + err);
            });
    }
    const onClickDelete = (pInfo) => {
        setIsBusy(true);
        apiDeleteUser(pInfo.id)
            .then((data) => {
                setIsBusy(false);
                let updateData = [...dataList]
                var storeIndex = updateData.findIndex(x => x.id == pInfo.id);
                updateData.splice(storeIndex, 1);
                var tmpData = [...updateData];
                setDataList(tmpData);
                setSearchList(tmpData);
            })
            .catch((err) => {
                setIsBusy(false);
                message.error(err);
            });
    }
    const onClickDetail = (pInfo) => {
      
    }
    const onClickEdit = async (pInfo) => {
        let info = pInfo
        var res = await showAddUserDialog({
            title: "Edit User",
            record: info,
            isEditing: true
        });
        if (res === null) return;

        setIsBusy(true);
        apiUpdateUser(res)
            .then((data) => {
                setIsBusy(false);
                if (data === null) {
                    message.error("There's something wrong while updating a User");
                }
                let updateData = [...dataList];
                var storeIndex = updateData.findIndex(x => x.id == data.id);
                updateData.splice(storeIndex, 1, data);
                setDataList(updateData)
                setSearchList(updateData)

            })
            .catch((err) => {
                setIsBusy(false);
                message.error(err);
            });
    }
    const handleDateFilter = (startDate, endDate) => {
        if (startDate == "" || endDate == "") {
            setSearchList([...dataList])
        } else {
            const start_date = new Date(startDate + "T00:00:00");
            const end_date = new Date(endDate + "T23:59:59");
            const tmpList = dataList.filter((info) => start_date <= new Date(info.update_timestamp.replace(/ /g, "T")) && new Date(info.update_timestamp.replace(/ /g, "T")) <= end_date)
            setSearchList([...tmpList])
        }
    }
    return (
        <CommonDivWidget>
            <Spin spinning={isBusy}>
                <h1>User</h1>
                <Row>
                    <Col>
                        <div style={{ fontFamily: 'mediumFont', padding: 20 }}>Date Filter Period : &nbsp;&nbsp;
                            <RangePicker size={'default'}
                                onChange={(e, date) => {
                                    if (date == null) {
                                        handleDateFilter("", "")
                                    } else {
                                        handleDateFilter(date[0], date[1])
                                    }

                                }} />
                        </div>
                    </Col>
                    <Col flex={'auto'}>
                        <div style={{ fontFamily: 'mediumFont', padding: 20 }}>
                            <TitleSearch
                                onSearch={handleSearch}
                                onChange={handleChange}
                                onPressEnter={handleSearch}
                            />
                        </div>
                    </Col>
                    <Col>
                        <div style={{ fontFamily: 'mediumFont', padding: 20 }}>
                            <CommonButton onClick={() => {
                                onNewUser()
                            }}>New</CommonButton>
                        </div>
                    </Col>
                </Row>

                <div>
                    <TableWidget
                        dataList={searchList}
                        onDetailAction={onClickDetail}
                        onUpdateAction={onClickEdit}
                        onDeleteAction={onClickDelete}
                    />
                </div>
            </Spin>
        </CommonDivWidget>
    )
}

export default UsersPage
